"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProductContentDataByTag = void 0;
const queries_1 = require("./queries");
const api_js_1 = __importDefault(require("../../utils/api.js"));
const pattern_library_utils_cookies_1 = require("@saatva-bits/pattern-library.utils.cookies");
const getProductContentDataByTag = async (apiRoutes, tags = [], prismicRef = null) => {
    try {
        const query = queries_1.GET_PRODUCT_CONTENT_DATA_BY_TAGS;
        const variables = { tags };
        const options = {
            prismicRef: prismicRef || pattern_library_utils_cookies_1.Cookies.get('prismicPreviewRef')
        };
        const { getProductDataByTags } = await (0, api_js_1.default)(apiRoutes.content, { query, variables, options });
        return getProductDataByTags;
    }
    catch (error) {
        console.error(`Error fetching product content data by tags: ${error}`);
        return [];
    }
};
exports.getProductContentDataByTag = getProductContentDataByTag;
//# sourceMappingURL=index.js.map